<ng-container *ngIf="!iconName">
  <ng-content></ng-content>
</ng-container>

<ng-container *ngIf="iconName">
  <rt-icon [name]="iconName"></rt-icon>
  <ng-container *ngIf="url">
    <a [href]="url" [target]="target">
      {{ label }}
    </a>
  </ng-container>

  <ng-container *ngIf="!url">
    {{ label }}
  </ng-container>
</ng-container>
